const data = [
  "Welcome to our website!",
  "Check out our latest updates.",
  "Join us for upcoming events!",
];

const Marquee = () => {
  return (
    <div className="heading-section">
      <div className="marquee-content">
        {data.map((text, index) => (
          <span key={index} className="marquee-text">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
